export default __webpack_public_path__ + "static/hand-31d91d76e3a6154191ee6b796e647a7f.png";